import localization from "assets/localization/localization";
import { useEffect, useState } from "react";

const useLatLng = () => {
  const [latlng, setLatlng] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      setLatlng(null);
      navigator.geolocation.getCurrentPosition(
        (e) => {
          let latitude = e.coords.latitude;
          let longitude = e.coords.longitude;
          setLatlng({
            lat: Number(latitude).toFixed(5),
            lng: Number(longitude).toFixed(5),
          });
        },
        function (error) {
          if (error.code == error.PERMISSION_DENIED) {
            setLatlng(false);
          }
        }
      );
    } else {
      let errorMsg = localization.geolocationNotSupport;
      setLatlng({ lat: errorMsg, lng: errorMsg });
    }
  }, []);

  return latlng;
};

export default useLatLng;
